import { Flower2 } from "lucide-react";
import { RecommendationCard } from "@/components/RecommendationCard";
import { CtaButton } from "@/components/CtaButton";

const Body = ({ s }) => (
  <>
    {s.subtitle && <p className="font-serif text-xl text-[#3B121A] mb-4">{s.subtitle}</p>}
    {s.profile && (s.letter === "A" || s.letter === "E") && (
      <p className="font-serif text-2xl text-[#3B121A] mb-4" data-testid={`section-${s.letter}-profile`}>{s.profile}</p>
    )}
    {s.journey && <p className="font-serif text-2xl text-[#3B121A] mb-4" data-testid="section-F-journey">{s.journey}</p>}
    <div className="space-y-4">{s.paragraphs.map((p, i) => <p key={i} className="fea-body">{p}</p>)}</div>
    {s.bullets.length > 0 && (
      <ul className="mt-5 space-y-3">
        {s.bullets.map((b) => (
          <li key={b} className="flex gap-3 fea-body"><Flower2 className="h-4 w-4 mt-1.5 shrink-0 text-[#C9A13B]" />{b}</li>
        ))}
      </ul>
    )}
    {s.item && <div className="mt-2"><RecommendationCard item={s.item} rank={s.letter === "H" ? 1 : 2} /></div>}
    {s.program && (
      <div className="mt-6 rounded-2xl border border-[#E5C158]/60 bg-[#FFF9EC] p-5" data-testid="support-program">
        <p className="font-serif text-xl text-[#800534]">{s.program.name}</p>
        <p className="fea-body mt-2">{s.program.description}</p>
      </div>
    )}
    {s.practices && (
      <div className="grid sm:grid-cols-3 gap-4 mt-6">
        {s.practices.map((p, i) => (
          <div key={p.name} className="rounded-2xl bg-[#FDF2F4] p-5" data-testid={`practice-${i}`}>
            <p className="font-serif text-lg text-[#800534]">{p.name}</p>
            <p className="text-[15px] leading-relaxed text-[#6E4450] mt-2">{p.text}</p>
          </div>
        ))}
      </div>
    )}
    {s.cta && <div className="mt-6"><CtaButton cta={s.cta} testId="membership-cta" /></div>}
    {s.ctas?.length > 0 && (
      <div className="flex flex-wrap gap-3 mt-6">
        {s.ctas.map((c, i) => (
          <CtaButton key={i} cta={c} variant={i === s.ctas.length - 1 ? "solid" : "outline"}
            testId={c.kind === "guide" || c.url?.includes("vcita") ? `section-${s.letter}-guide-call-button` : `section-${s.letter}-cta-${i}`} />
        ))}
      </div>
    )}
  </>
);

export const ReportSection = ({ s }) => {
  const highlight = s.letter === "G";
  return (
    <section className={`fea-section ${highlight ? "fea-section-highlight" : ""}`} data-testid={`section-${s.letter}`}>
      <div className="flex items-baseline gap-4 mb-5">
        <span className="fea-letter">{s.letter}</span>
        <h2 className="font-serif text-2xl sm:text-3xl font-semibold text-[#800534]">{s.title}</h2>
      </div>
      <Body s={s} />
    </section>
  );
};
